export enum APP_ID {
  ANDROID = '1',
  IOS = '2',
  WIN = '3'
}
